module.exports = __webpack_public_path__ + "res/blackjack.540ef71070a8d969b71479445860c515.webp";